<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="this.$route.params.id + ' - ' + this.$route.params.name">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-input
                  :label="$t('tables.products.assembly_sequence')"
                  v-model="params.assembly_sequence"
                  value="product.assembly_sequence"
                />
              </div>

              <div class="flex md3 sm6 xs12">
                <va-input
                  :label="$t('tables.products.address')"
                  v-model="params.address"
                  value="product.address"
                />
              </div>
            </div>

            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="green"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update(params)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>

              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'product_sequence', params: { current_page: this.$route.params.current_page, 
                    search: this.$route.params.search, delivery_date: this.$route.params.delivery_date, 
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>

            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSequenceAPI from '@/services/ProductSequenceAPI'
import BackButton from '../../shared/BackButton'
import { mapState } from "vuex";

export default {
  name: 'form-load-sequence',
  components: { BackButton },
  data () {
    return {
      params: {
        id: '',
        address: '',
        assembly_sequence: ''
      },
      sequence_changed: false
    }
  },

  computed: {
    ...mapState([]),
  },

  async mounted(){
    await ProductSequenceAPI.getProductById(this.$route.params.id).then(response => {

      this.params.id = response.data.product.id
      this.params.address = response.data.product.address
      this.params.assembly_sequence = response.data.product.assembly_sequence
    })
  },
  methods: {
    async update (params) {
      if (this.sequence_changed) {
        this.saveSequence(this.params.assembly_sequence, this.params.id)
      }
      await ProductSequenceAPI.updateProduct(params).then(response => {
        this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
        })
        this.$router.push('/admin/tables/product_sequence')
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      },
    async saveSequence(assembly_sequence, product_id) {
      ProductSequenceAPI.saveSequence(assembly_sequence, product_id).then( response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
  },
  watch: {
    "params.assembly_sequence": function(newSequence, oldSequence) {
      if(newSequence != oldSequence && oldSequence != ""){
        this.sequence_changed = true
      }
    }
  }
}
</script>